export const PATH_APP = {
	root: "/",
	login: {
		root: "/login",
	},
	auth: {
		root: "/auth",
		login: "/auth/login",
		forgot: "/auth/forgot",
		reset: "/auth/resetPassword",
		invite: "/auth/memberInvite",
	},
	application: {
		root: "/application",
		dashboard: "/application/:id/dashboard",
		setting: "/application/:id/setting",
	},
	price: {
		root: "/price",
	},
	account: {
		root: "/account",
		profile: "/account/profile",
		security: "/account/security",
		delete: "/account/delete",
	},
	organization: {
		root: "/organization",
		general: "/organization/general",
		usage: "/organization/usage",
		applications: "/organization/applications",
		members: "/organization/members",
		billing: {
			root: "/organization/billing",
			information: "/organization/billing/information",
			invoices: "/organization/billing/invoices",
			pricing: "/organization/billing/pricing",
			applicationList: "/organization/billing/applicationList",
		},
		contact: "/organization/contact",
		contract: "/organization/contract",
	},
} as const;
